import React, { Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { SiteLayout } from "./layout/SiteLayout";
import { RouteFallback } from "./components/common/RouteFallback";

const Home = React.lazy(() =>
  import("./pages/Home").then((m) => ({
    default: m.Home,
  }))
);
const About = React.lazy(() =>
  import("./pages/About").then((m) => ({
    default: m.About,
  }))
);
const OurWork = React.lazy(() =>
  import("./pages/OurWork").then((m) => ({
    default: m.OurWork,
  }))
);
const Contact = React.lazy(() =>
  import("./pages/Contact").then((m) => ({
    default: m.Contact,
  }))
);
const Privacy = React.lazy(() =>
  import("./pages/Privacy").then((m) => ({
    default: m.Privacy,
  }))
);
const Terms = React.lazy(() =>
  import("./pages/Terms").then((m) => ({
    default: m.Terms,
  }))
);

const App: React.FC = () => {
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <SiteLayout>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<About />} />
            <Route path="/work" element={<OurWork />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
          </Routes>
        </Suspense>
      </SiteLayout>
    </Router>
  );
};

export default App;
